import React from 'react';
import { FaFacebookF, FaGoogle } from 'react-icons/fa';
import firebase, { providers } from '../../services/firebase';

export default function SocialButtons() {
  const facebook = () => firebase.auth().signInWithRedirect(providers.facebook());
  const google = () => firebase.auth().signInWithRedirect(providers.google());

  return (
    <>
      <div className="text-center w-100 mt-1 mb-1 social-title">
        <span> Faça login via</span>
      </div>
      <div className="d-flex flex-row justify-content-between align-items-center social-holder">
        <button type="button" className="btn btn-block btn-social btn-facebook" onClick={facebook}>
          <FaFacebookF />
          Facebook
        </button>
        <button type="button" className="btn btn-block btn-social btn-google" onClick={google}>
          <FaGoogle />
          Google
        </button>
      </div>
    </>
  );
}
